import { Sender } from '@ant-design/x'
import { Flex } from 'antd'

import type { PendingAttachment } from './attachmentUploads'
import { ChatAttachmentChip } from './ChatAttachmentChip'

type Props = {
  items: PendingAttachment[]
  onRemove: (localId: string) => void
  onRetry: (localId: string) => void
}

/** The composer's header slot: one chip per staged file. */
export const ChatAttachmentsHeader = ({ items, onRemove, onRetry }: Props) => (
  <Sender.Header open closable={false}>
    <Flex wrap gap="small">
      {items.map((item) => (
        <ChatAttachmentChip
          key={item.localId}
          item={item}
          onRemove={onRemove}
          onRetry={onRetry}
        />
      ))}
    </Flex>
  </Sender.Header>
)
